import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Dashboard from './pages/Dashboard';
import BayesApp from './pages/BayesApp';
import Auth from './pages/Auth';
import GefaessKalkulator from './pages/GefaessKalkulator';

function App() {
    // Wir prüfen beim Start, ob schon ein Token im Browser gespeichert ist
    const [token, setToken] = useState(localStorage.getItem('token'));

    // Wenn sich der Token ändert (z.B. beim Ausloggen), aktualisieren wir den State
    useEffect(() => {
        const storedToken = localStorage.getItem('token');
        setToken(storedToken);
    }, []);

    const handleLogout = () => {
        localStorage.removeItem('token');
        setToken(null);
    };

    // Wenn KEIN Token da ist, zeigen wir NUR den Login-Bildschirm
    if (!token) {
        return <Auth onLogin={(newToken) => setToken(newToken)} />;
    }

    // Wenn ein Token da ist, zeigen wir die normale Klinik-App
    return (
        <Router>
            <div className="flex flex-row h-screen w-full overflow-hidden bg-slate-100">

                {/* Wir übergeben der Sidebar die Logout-Funktion, damit wir später einen Abmelden-Button einbauen können */}
                <Sidebar onLogout={handleLogout} />

                <main className="flex-1 h-full overflow-auto p-4 md:p-8">
                    <Routes>
                        <Route path="/" element={<Dashboard />} />
                        <Route path="/bayes" element={<BayesApp />} />
                        <Route path="/gefaess" element={<GefaessKalkulator />} />
                        <Route path="/patients" element={<div className="p-10 text-xl font-bold">Patientenverwaltung (In Bau)</div>} />
                        {/* Fängt alle falschen URLs ab und leitet zum Dashboard */}
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </main>

            </div>
        </Router>
    );
}

export default App;